(function () {
  document.querySelectorAll('.cake-priced').forEach(initCakePriced);

  function initCakePriced(root) {
    const config = root.querySelector('[data-cake-priced-config]');
    if (!config) return;

    const portionPrice = parseInt(config.dataset.portionPrice, 10) || 0;
    const inscriptionVariantId = config.dataset.inscriptionVariantId;
    const packagingVariantId = config.dataset.packagingVariantId;
    const packagingPrice = parseInt(config.dataset.packagingPrice, 10) || 0;
    const inscriptionPrice = parseInt(config.dataset.inscriptionPrice, 10) || 0;

    // Lead time counts Monday to Friday only: Saturday is a pickup day, not a
    // production day (Regulamin § 2). Sunday is the one day nothing can be
    // collected either. The number of days is editable per section in the
    // theme customizer (min_business_days).
    const CLOSED_WEEKDAY = 0;

    function isBusinessDay(date) {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    }

    function toDateInputValue(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    function earliestPickupDate() {
      const parsedDays = parseInt(config.dataset.minBusinessDays, 10);
      const businessDays = isNaN(parsedDays) ? 1 : parsedDays;
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      let added = 0;
      while (added < businessDays) {
        date.setDate(date.getDate() + 1);
        if (isBusinessDay(date)) added++;
      }
      return date;
    }

    const dateInput = root.querySelector('[data-cake-date-input]');
    const dateError = root.querySelector('[data-cake-date-error]');

    const CLOSED_MESSAGE = dateError ? dateError.textContent.trim() : '';

    // The minimum used to be enforced by the input's "min" attribute alone.
    // Chrome and Firefox refuse to submit a form whose date falls below it, so
    // the lead time held; Safari submits anyway and the cake could be ordered
    // for the same day. The rule is therefore checked here too, and the
    // attribute is left in place only to grey the earlier days out.
    function pickupDateIssue() {
      if (!dateInput || !dateInput.value) return null;
      const [year, month, day] = dateInput.value.split('-').map(Number);
      const selected = new Date(year, month - 1, day);
      if (isNaN(selected.getTime())) return 'Wybierz poprawną datę odbioru.';
      if (selected.getDay() === CLOSED_WEEKDAY) return CLOSED_MESSAGE;
      const earliest = earliestPickupDate();
      if (selected < earliest) {
        return 'Najwcześniejszy możliwy termin odbioru to ' + earliest.toLocaleDateString('pl-PL') + '.';
      }
      return null;
    }

    function showDateIssue(message) {
      if (!dateError) return;
      dateError.textContent = message || CLOSED_MESSAGE;
      dateError.hidden = !message;
    }

    if (dateInput) {
      dateInput.min = toDateInputValue(earliestPickupDate());
      dateInput.addEventListener('change', () => {
        if (!dateInput.value) {
          showDateIssue(null);
          return;
        }
        const issue = pickupDateIssue();
        // A Sunday is cleared, as it always was; a date that is merely too
        // early keeps its value while the customer corrects it.
        if (issue === CLOSED_MESSAGE) dateInput.value = '';
        showDateIssue(issue);
      });
    }

    const mainImage = root.querySelector('[data-cake-main-image]');
    const mainPlaceholder = root.querySelector('[data-cake-main-placeholder]');
    const flavorImage = root.querySelector('[data-cake-flavor-image]');
    const flavorSlide = root.querySelector('[data-cake-flavor-slide]');
    const gallerySlider = root.querySelector('.custom-cake__gallery-slider');
    const totalPriceEl = root.querySelector('[data-cake-total-price]');
    const portionsNote = root.querySelector('[data-cake-portions-note]');

    // Tooltips (info icons + pattern swatches) are centered on their trigger
    // by default. When the trigger sits close to the edge of the page, the
    // tooltip can extend past the viewport — even while hidden (opacity: 0
    // still occupies layout space), which inflates the page's real scrollable
    // width. Nudge each tooltip back into view right before it's shown,
    // measuring against the viewport itself so this holds regardless of the
    // browser engine's own overflow/layout quirks.
    function wireTooltipReposition(trigger, tooltip, events) {
      if (!tooltip) return;
      const reposition = () => {
        tooltip.style.marginLeft = '';
        const margin = 8;
        const tooltipRect = tooltip.getBoundingClientRect();
        let shift = 0;
        const viewportWidth = document.documentElement.clientWidth;
        if (tooltipRect.left < margin) {
          shift = margin - tooltipRect.left;
        } else if (tooltipRect.right > viewportWidth - margin) {
          shift = viewportWidth - margin - tooltipRect.right;
        }
        if (shift !== 0) {
          tooltip.style.marginLeft = shift + 'px';
        }
      };
      // Run once immediately: even hidden (opacity: 0), a tooltip still
      // occupies layout space, so an unshifted one near the edge would
      // inflate the page's real scrollable width from the moment it loads.
      reposition();
      events.forEach((eventName) => trigger.addEventListener(eventName, reposition));
      // Re-check whenever the tooltip's own box actually changes size — e.g.
      // once web fonts finish loading and its max-content text re-measures,
      // which happens after our initial synchronous call above.
      if (window.ResizeObserver) {
        new ResizeObserver(reposition).observe(tooltip);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(reposition);
      }
      window.addEventListener('resize', reposition);
    }

    root.querySelectorAll('.custom-cake__info-icon').forEach((icon) => {
      wireTooltipReposition(icon, icon.querySelector('.custom-cake__tooltip--info'), ['mouseenter', 'focus']);
    });

    root.querySelectorAll('.custom-cake__pattern').forEach((pattern) => {
      wireTooltipReposition(pattern, pattern.querySelector('.custom-cake__tooltip--pattern'), ['mouseenter']);
    });
    const quantityInput = root.querySelector('[data-quantity-input]');
    const variantIdInput = root.querySelector('.product-express__variant-id-fallback');
    const inscriptionInput = root.querySelector('[data-cake-inscription-input]');
    const form = root.querySelector('.product-express__form form');
    const submitButton = root.querySelector('[data-cake-submit]');
    const errorWrapper = root.querySelector('.product-express__error-message-wrapper');
    const errorMessage = root.querySelector('.product-express__error-message');

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' zł';
    }

    function currentQuantity() {
      return quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
    }

    function updateTotalPrice() {
      if (!totalPriceEl) return;
      const hasInscription = !!(inscriptionInput && inscriptionInput.value.trim());
      totalPriceEl.textContent = formatMoney(
        portionPrice * currentQuantity() + packagingPrice + (hasInscription ? inscriptionPrice : 0)
      );
    }

    // Fixed portion-size options (4/6/8/10/12) each just set the quantity
    // sent to Shopify; the real per-portion price still comes from the
    // product's own variant price (portionPrice), so changing that price in
    // the Shopify Admin updates every button's displayed total automatically
    // — no separate variant per size needed.
    const portionSelect = root.querySelector('[data-portion-select]');
    const customPortionsWrap = root.querySelector('[data-custom-portions]');
    const customPortionsValue = root.querySelector('[data-custom-portions-value]');
    const customPortionsDecrease = root.querySelector('[data-custom-portions-decrease]');
    const customPortionsIncrease = root.querySelector('[data-custom-portions-increase]');
    const customPortionsMin = quantityInput ? parseInt(quantityInput.dataset.customPortionsMin, 10) || 1 : 1;

    // The last option ("Niestandardowa ilość…") reveals the stepper, which
    // then drives the quantity instead of the dropdown.
    function applyPortionChoice() {
      const choice = portionSelect && portionSelect.selectedOptions[0];
      if (!choice) return;
      const isCustom = choice.hasAttribute('data-portion-custom');
      if (customPortionsWrap) customPortionsWrap.hidden = !isCustom;
      const count = isCustom
        ? parseInt((customPortionsValue ? customPortionsValue.textContent : customPortionsMin), 10)
        : parseInt(choice.dataset.portionCount, 10);
      if (quantityInput && count) quantityInput.value = count;
      updateTotalPrice();
    }

    if (portionSelect) {
      portionSelect.addEventListener('change', applyPortionChoice);
      // A browser can restore the previous choice after a reload.
      applyPortionChoice();
    }

    function updateCustomPortionsButtonState() {
      if (!customPortionsValue || !customPortionsDecrease) return;
      customPortionsDecrease.disabled = parseInt(customPortionsValue.textContent, 10) <= customPortionsMin;
    }

    if (customPortionsValue && customPortionsDecrease && customPortionsIncrease) {
      updateCustomPortionsButtonState();
      customPortionsDecrease.addEventListener('click', () => {
        const next = Math.max(customPortionsMin, parseInt(customPortionsValue.textContent, 10) - 1);
        customPortionsValue.textContent = next;
        updateCustomPortionsButtonState();
        if (quantityInput) quantityInput.value = next;
        updateTotalPrice();
      });
      customPortionsIncrease.addEventListener('click', () => {
        const next = Math.max(customPortionsMin, parseInt(customPortionsValue.textContent, 10) + 1);
        customPortionsValue.textContent = next;
        updateCustomPortionsButtonState();
        if (quantityInput) quantityInput.value = next;
        updateTotalPrice();
      });
    }

    if (inscriptionInput) {
      inscriptionInput.addEventListener('input', updateTotalPrice);
    }

    updateTotalPrice();

    function updateSelectedPattern(radio) {
      if (!mainImage || !radio || !radio.dataset.patternImageSrc) return;
      mainImage.src = radio.dataset.patternImageSrc;
      mainImage.hidden = false;
      if (mainPlaceholder) mainPlaceholder.hidden = true;
    }

    // Mousse models are each made in one fixed size, so picking a model sets
    // both the quantity sent to Shopify and the price shown. Sections that
    // keep a portions dropdown (monoporcje) carry no data-portion-count here,
    // so this stays inert for them.
    function applyPatternPortions(radio) {
      const count = radio ? parseInt(radio.dataset.portionCount, 10) : NaN;
      if (!count) return;
      if (quantityInput) quantityInput.value = count;
      if (portionsNote) {
        portionsNote.textContent = count + ' ' + (radio.dataset.portionsWord || 'porcji') + ' · opakowanie w cenie';
      }
      updateTotalPrice();
    }

    function updateSelectedFlavor(radio) {
      if (!flavorImage) return;
      const hasImage = !!(radio && radio.dataset.flavorImageSrc);
      if (hasImage) {
        flavorImage.src = radio.dataset.flavorImageSrc;
      }
      // The cross-section photo is named after the chosen flavour.
      flavorImage.alt = hasImage ? radio.value : '';
      // The slide (not just the image) is hidden/shown, so the gallery
      // slider's own slide count — and its "1 / 2" counter — stays accurate.
      if (flavorSlide) {
        const wasHidden = flavorSlide.hidden;
        flavorSlide.hidden = !hasImage;
        if (wasHidden !== flavorSlide.hidden && gallerySlider && typeof gallerySlider.resetPages === 'function') {
          gallerySlider.resetPages();
        }
      }
    }

    root.querySelectorAll('[data-pattern-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        updateSelectedPattern(radio);
        applyPatternPortions(radio);
      });
    });
    const checkedPattern = root.querySelector('[data-pattern-radio]:checked');
    if (checkedPattern) {
      updateSelectedPattern(checkedPattern);
      applyPatternPortions(checkedPattern);
    }

    root.querySelectorAll('[data-flavor-radio]').forEach((radio) => {
      radio.addEventListener('change', () => updateSelectedFlavor(radio));
    });
    const checkedFlavor = root.querySelector('[data-flavor-radio]:checked');
    if (checkedFlavor) updateSelectedFlavor(checkedFlavor);

    // Multi-select color swatches (e.g. monoporcje's "up to N colors") — only
    // present where the section opts in via data-color-group; other cake
    // sections keep the original single-choice radio color picker untouched.
    const colorGroup = root.querySelector('[data-color-group]');
    if (colorGroup) {
      const maxColors = parseInt(colorGroup.dataset.colorMax, 10) || 1;
      const colorCheckboxes = colorGroup.querySelectorAll('[data-color-checkbox]');
      const colorValueInput = root.querySelector('[data-color-value]');

      function updateColorSelection() {
        const checked = Array.from(colorCheckboxes).filter((checkbox) => checkbox.checked);
        colorCheckboxes.forEach((checkbox) => {
          checkbox.disabled = !checkbox.checked && checked.length >= maxColors;
        });
        if (colorValueInput) {
          colorValueInput.value = checked.map((checkbox) => checkbox.value).join(', ');
        }
      }

      colorCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', updateColorSelection);
      });
      updateColorSelection();
    }

    // "Sposób projektu" toggle — only present for cake types that allow inspiration.
    const designToggle = root.querySelector('[data-design-toggle]');
    const patternsWrap = root.querySelector('[data-patterns-wrap]');
    const inspirationField = root.querySelector('[data-inspiration-upload]');
    if (designToggle) {
      root.querySelectorAll('[data-design-mode-radio]').forEach((radio) => {
        radio.addEventListener('change', () => {
          const mode = radio.dataset.designMode;
          if (patternsWrap) patternsWrap.hidden = mode !== 'pattern';
          if (inspirationField) inspirationField.hidden = mode !== 'inspiration';
        });
      });
    }

    const fileInputWrap = root.querySelector('[data-file-input-wrap]');
    if (fileInputWrap) {
      const fileInput = fileInputWrap.querySelector('[data-file-input]');
      const clearButton = fileInputWrap.querySelector('[data-file-input-clear]');
      if (fileInput && clearButton) {
        fileInput.addEventListener('change', () => {
          clearButton.hidden = !fileInput.value;
        });
        clearButton.addEventListener('click', () => {
          fileInput.value = '';
          clearButton.hidden = true;
        });
      }
    }

    if (!form) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (errorWrapper) errorWrapper.hidden = true;

      const variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) {
        showError('Nie udało się dodać produktu do koszyka.');
        return;
      }

      if (dateInput && !dateInput.value) {
        showError('Wybierz datę odbioru.');
        dateInput.focus();
        return;
      }

      const dateIssue = pickupDateIssue();
      if (dateIssue) {
        showError(dateIssue);
        showDateIssue(dateIssue);
        dateInput.focus();
        return;
      }

      const timeInput = form.querySelector('input[type="time"][required]');
      if (timeInput && !timeInput.value) {
        showError('Wybierz godzinę odbioru.');
        timeInput.focus();
        return;
      }

      const properties = {};
      form.querySelectorAll('[name^="properties["]').forEach((field) => {
        const key = field.name.match(/properties\[(.+)\]/)[1];
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (field.checked) properties[key] = field.value;
          return;
        }
        if (field.value) properties[key] = field.value;
      });

      const items = [{ id: Number(variantId), quantity: currentQuantity(), properties: properties }];

      if (packagingVariantId) {
        items.push({ id: Number(packagingVariantId), quantity: 1 });
      }

      if (inscriptionInput && inscriptionInput.value.trim() && inscriptionVariantId) {
        items.push({ id: Number(inscriptionVariantId), quantity: 1 });
      }

      if (submitButton) submitButton.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data: data })))
        .then(({ ok, data }) => {
          if (!ok) {
            throw new Error(data.description || data.message || 'Nie udało się dodać produktu do koszyka.');
          }
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch((error) => {
          showError(error.message);
        })
        .finally(() => {
          if (submitButton) submitButton.disabled = false;
        });
    });

    function showError(message) {
      if (!errorWrapper || !errorMessage) return;
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
    }
  }
})();
